import { Row, StandardPanel, StandardPanelParams } from "./standard.panel";

export interface StandardPanelViewParams extends StandardPanelParams {
    items: Array<{
        label: string;
        value: string | number | null | undefined;
    }>
}

export function StandardViewPanel(params: StandardPanelViewParams) {
    return (
        <StandardPanel {...params} >
            {
                params.items.map((row, index) => (
                    <Row key={index} label={row.label} value={row.value} />
                ))
            }
        </StandardPanel >
    )
}
